export interface TransferControlResult {
  success: boolean,
  responseMessage?: string,
}